import { z } from 'zod';

export const feedbackSchema = z.object({
  conversation_id: z.string().uuid('Conversation ID must be a valid UUID').optional(),
  message_id: z.string().min(1, 'Message ID is required'),
  feedback_type: z.enum(['thumbs_up', 'thumbs_down'], {
    required_error: 'Feedback type is required',
    invalid_type_error: 'Feedback type must be either thumbs_up or thumbs_down',
  }),
  comment: z.string().optional(),
  rating: z.number().int().min(1).max(5).optional(),
});

export type FeedbackData = z.infer<typeof feedbackSchema>;
